<template>
  <ExpandBarTransition>
    <div v-if="show" class="section-bar">
      <BaseBar
        class="section-bar__title bg-secondary text-white hover-pointer"
        @click.native="$emit('clicked', sectionSurveyLevel)"
      >
        <div class="section-bar-title__title d-inline-flex items-center">
          <span class="text-white pe-2">{{ suffixTitle }}</span>
          {{ section.name }}
        </div>
        <EntityBarProgress
          :current-question-ids="currentQuestionIds"
          class="section-bar-title__progress text-white"
        />
      </BaseBar>

      <ExpandBarButton
        class="section-bar__btn"
        :open="showDirectChildren"
        type="section"
        @click="expand()"
      />

      <div class="section-bar__content d-flex flex-column">
        <ThemeBar
          v-for="[themeKey, theme] of themes"
          :key="getThemeKey(themeKey)"
          :show="showDirectChildren"
          :theme="theme"
          @clicked="emitThemeClick"
        />
      </div>
    </div>
  </ExpandBarTransition>
</template>

<script>
import BaseBar from '../Components/BaseBar.vue'
import ThemeBar from './ThemeBar.vue'
import ExpandBarTransition from './Transitions/ExpandBarTransition.vue'
import ExpandBarButton from './ExpandBarButton.vue'
import EntityBarProgress from './EntityBarProgress.vue'

export default {
  components: {
    BaseBar,
    ThemeBar,
    ExpandBarTransition,
    ExpandBarButton,
    EntityBarProgress,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showDirectChildren: false,
      sectionSurveyLevel: new Map([['sectionId', this.section.display_order]]),
    }
  },
  computed: {
    themes() {
      return this.section.themes.reduce((themeMap, theme) => {
        return themeMap.set(theme.display_order, theme)
      }, new Map())
    },
    suffixTitle() {
      return `${this.section.section_number}`
    },
    currentQuestionIds() {
      return this.section.question_ids ?? []
    },
  },
  methods: {
    getThemeKey(themeKey) {
      return `theme-${this.section.id}-${themeKey}`
    },
    expand() {
      this.showDirectChildren = !this.showDirectChildren
    },
    emitThemeClick(themeId) {
      this.sectionSurveyLevel.set('themeId', themeId)
      this.$emit('clicked', this.sectionSurveyLevel)
    },
  },
}
</script>
<style lang="scss">
.section-bar {
  display: grid;
  grid-template-columns: auto 3em;
  grid-template-rows: max-content;
  grid-template-areas: 'title btn' 'content .';

  &__title {
    padding: 1.3rem 2.5rem !important;
    grid-area: title;
    font-size: 1.3rem;
    line-height: 1em;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.121rem;
    display: flex;
    justify-content: space-between;
  }
  &__btn {
    grid-area: btn;
  }
  &__content {
    width: 90%;
    place-self: end;
    grid-area: content;
  }
}
</style>
